import { reducer, defaultState } from "./reducer";

import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import createDebounce from "redux-debounced";

export const configureStore = () => {
  const enhancers = [applyMiddleware(createDebounce(), thunk)];

  const actionCreators = {};

  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Options: http://extension.remotedev.io/docs/API/Arguments.html
        actionCreators
      })
    : compose;

  const enhancer = composeEnhancers(...enhancers);

  const store = createStore(reducer, defaultState, enhancer);

  return store;
};
